import { GameState } from '../game/GameState';
import { DataRegistry } from './DataRegistry';
import { WarManager } from './WarManager';

export class NavalSiegeManager {
  static readonly instance = new NavalSiegeManager();

  applyMonthlyPressure() {
    const campaign = GameState.instance.requireCampaign();
    for (const siege of Object.values(campaign.sieges)) {
      const province = campaign.provinces[siege.provinceId];
      if (!province || !DataRegistry.instance.provinces[province.id]?.port || !province.blockadedBy) continue;
      if (province.blockadedBy !== siege.besiegerFactionId && !WarManager.instance.areEnemies(province.blockadedBy, siege.defenderFactionId)) continue;
      siege.blockade = true;
      siege.progress = Math.min(100, siege.progress + 5);
      siege.garrison = Math.max(0, siege.garrison - 12);
      province.devastation = Math.min(100, province.devastation + 1);
    }
  }

  syncFlags() {
    const campaign = GameState.instance.requireCampaign();
    for (const siege of Object.values(campaign.sieges)) {
      const province = campaign.provinces[siege.provinceId];
      siege.blockade = Boolean(province?.blockadedBy && DataRegistry.instance.provinces[siege.provinceId]?.port);
    }
  }
}